import React from 'react';

function ErrorFallback({ error, resetErrorBoundary }) {
    return (React.createElement("div", { role: "alert" },
        React.createElement("p", null, "Something went wrong:"),
        React.createElement("pre", null, error.message),
        React.createElement("button", { onClick: resetErrorBoundary }, "Try again")));
}

export { ErrorFallback };
//# sourceMappingURL=errorFallback.js.map
